// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uovsm","option":"styles_option__2ddFg","active":"styles_active__1XGSA"};